import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Dropdown, DropdownExpandableButton } from "azure-devops-ui/Dropdown";
import { IListBoxItem } from "azure-devops-ui/ListBox";
import { Observer } from "azure-devops-ui/Observer"; 
import { DropdownSelection } from "azure-devops-ui/Utilities/DropdownSelection";
import { dropdownItems } from "./Data";


export default class DropdownButtonExample extends React.Component {
    private selection = new DropdownSelection();
    private selectedItem = new ObservableValue<string>("");

    public render() {
        const placeholder = "Select an Option";
        return (
            <div style={{ margin: "8px" }}>
                <Observer selectedItem={this.selectedItem}>
                    {() => (
                        <Dropdown
                            ariaLabel={this.selectedItem.value ? "Button Dropdown " + this.selectedItem.value + " selected" : "Button Dropdown " + placeholder}
                            className="example-dropdown"
                            placeholder={placeholder}
                            items={dropdownItems}
                            selection={this.selection}
                            renderExpandable={props => <DropdownExpandableButton {...props} />}
                            onSelect={this.onSelect}
                        />
                    )}
                </Observer>
            </div>
        );
    }

    private onSelect = (event: React.SyntheticEvent<HTMLElement>, item: IListBoxItem<{}>) => {
        this.selectedItem.value = item.text || "";
    };
}
